import { useContext, useEffect, useState } from 'react';
import {useTranslation} from 'react-i18next';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faRoad, faStar, faBook } from '@fortawesome/free-solid-svg-icons';

import UserContext from '../../../store/user-context';
import Learning from './Learning/Learning';
import Settings from './Settings/Settings';
import HoF from './HoF/HoF';
import LearntFragments from './Fragments/Fragments';

const Dashboard = () => {
    const {t: translate } = useTranslation();    
    const { user } = useContext(UserContext);
    const locale = navigator.language ? navigator.language : 'en-US' //Fallback to english
    let dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    let createdDate  = new Date(user.user.createdAt);
    const [activeTab, setActiveTab] = useState('');
    const { version } = window['appConfig'];
    // eslint-disable-next-line no-undef
    const build = `${process.env.REACT_APP_BUILD_VERSION}`;

    const handleLearningLangUpdate = () => {
        localStorage.removeItem('glup'); //Forces each tab to reload the data it has
    }

    useEffect(() => {
        localStorage.removeItem('glup'); //Forces each tab to reload the data it has
    },[])

    return (
        <section className="section section__user-dashboard">
            <div className={`user-dashboard-container ${activeTab !== '' ?  'sections-active' : ''}`}>
                <div className="user-dashboard">
                    <div className="user-dashboard__header">
                        <h4 className="user-dashboard__title">{user.user.firstname}&apos;s {translate('profile')}</h4>
                        <p className='user-dashboard__subtitle'>{translate('golingo-since')} {createdDate.toLocaleDateString(locale, dateOptions)}</p>
                    </div>
                    <div className='user-dashboard__options'>
                        <div className={`user-dashboard__option ${activeTab === 'journey' ? 'active' : ''}`} 
                        onClick={() => {setActiveTab('journey')}}
                    >
                            <div className='option__icon'>
                                <FontAwesomeIcon icon={faRoad} size="2x" />
                            </div>
                            <p className='option__title'>{translate('learning-journey')}</p>
                        </div>
                        <div 
                            className={`user-dashboard__option user-dashboard__option--gold ${activeTab === 'hof' ? 'active' : ''}`} 
                            onClick={() => {setActiveTab('hof')}}
                        >
                            <div className='option__icon'>
                                <FontAwesomeIcon icon={faStar} size="2x" />
                            </div>
                            <p className='option__title'>{translate('hof')}</p>
                        </div>
                        <div 
                            className={`user-dashboard__option user-dashboard__option--green ${activeTab === 'fragments' ? 'active' : ''}`} 
                            onClick={() => {setActiveTab('fragments')}}
                        >
                            <div className='option__icon'>
                                <FontAwesomeIcon icon={faBook} size="2x" />
                            </div>
                            <p className='option__title'>{translate('fragments')}</p>
                        </div>
                        <div 
                            className={`user-dashboard__option user-dashboard__option--blue ${activeTab === 'settings' ? 'active' : ''}`} 
                            onClick={() => {setActiveTab('settings')}}
                        >
                            <div className='option__icon'>
                                <FontAwesomeIcon icon={faCog} size="2x" />
                            </div>
                            <p className='option__title'>{translate('settings')}</p>
                        </div>
                    </div>
                    <span id="version">
                        {version} (build {build})
                    </span>
                </div>
                <div className='user-dashboard__sections'>
                    {activeTab === '' && (
                        <div className='dashboard-landing'>
                            <h2 className='landing__title'>{translate('welcome-back')}, {user.user.firstname}</h2>
                            <p>{translate('select-option-dashboard')}</p>
                        </div>
                    )}
                    {activeTab === 'journey' && <Learning setActiveSection={setActiveTab} locale={user.user.language} />}
                    {activeTab === 'hof' && <HoF setActiveSection={setActiveTab} />}
                    {activeTab === 'fragments' && <LearntFragments setActiveSection={setActiveTab} />}
                    {activeTab === 'settings' && <Settings setActiveSection={setActiveTab} handleLearningLangUpdate={handleLearningLangUpdate}/>}
                </div>
            </div>
        </section>
    )
}

export default Dashboard;